<mat-dialog-content class="signUp">
    <div>
        <div class="closeHeader">
            <div class="row">
                <div class="col-5 logo">
                </div>
                <div class="col-7 closeIcon">
                    <span class="" (click)="closeDialog()">X</span>
                </div>
            </div>
        </div>
        <div class="" [ngClass]="{ar: translate.currentLang =='ar'}">

            <div class="row m-0">
                <div class="col-12 col-md-4 p-0 img-section  d-md-flex">
                    <p class="img-text"> {{translate.currentLang=='en'?
                        'Explore the world deeper with us':
                        'اكتشف العالم أعمق معنا'}}
                    </p>

                </div>

                <div class="col-12 col-md-8 p-0">
                    <div class="closeIconWeb">
                        <span class="" (click)="closeDialog()">X</span>
                    </div>
                    <form [formGroup]="authService.registerForm" class="form-container">
                        <div class="row">

                            <div class="col-12 mb-3">
                                <h1 class="header-text">{{translate.currentLang=='en'?'Sign up':'إنشاء حساب'}}</h1>
                            </div>




                            <div class="col-12 col-lg-6 col-md-6">
                                <mat-form-field color="accent" appearance="fill" class="authForm">
                                    <input matInput [placeholder]=" lang == 'en' ? 'Enter your first name' : 'ادخل اسمك الاول'"  formControlName="firstName">
                                    <mat-error *ngIf="getRegisterFormControl('firstName').touched&& getRegisterFormControl('firstName').invalid" >{{getFirstNameErrorMessage(getRegisterFormControl('firstName'),lang)}}  </mat-error>
                                </mat-form-field>

                            </div>

                            <div class="col-12 col-lg-6 col-md-6">
                                <mat-form-field color="accent" appearance="fill" class="authForm">
                                    <input matInput [placeholder]=" lang == 'en' ? 'Enter your last name' : 'ادخل اسمك الاخير'" formControlName="lastName">
                                    <mat-error *ngIf="getRegisterFormControl('lastName').touched&& getRegisterFormControl('lastName').invalid" >{{getLastNameErrorMessage(getRegisterFormControl('lastName'),lang)}}</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-12">
                                <ngx-intl-tel-input
                                color="accent"
                                [cssClass]="'phone'"
                                [preferredCountries]="['eg','us', 'gb']"
                                [enableAutoCountrySelect]="true"
                                [enablePlaceholder]="true"
                                [searchCountryFlag]="true"
                                [selectFirstCountry]="false"
                                [selectedCountryISO]="CountryISO.Egypt"
                                [maxLength]="15"
                                [phoneValidation]="false"
                                formControlName="userPhoneNumber">
                                </ngx-intl-tel-input>
                                        <!-- <input
                                        type="tel"
                                        class="form-control phone"
                                        placeholder="Enter phone number"
                                        formControlName="userPhoneNumber"
                                        pattern="^[0-9]{10,15}$" 
                                        required
                                        /> -->

                                <mat-error *ngIf="getRegisterFormControl('userPhoneNumber').touched && getRegisterFormControl('userPhoneNumber').invalid">
                                    {{ getPhoneErrorMessage }}
                                </mat-error>
                            </div>
                            <div class="col-12">
                                <mat-form-field color="accent"  appearance="fill" class="w-100">
                                <input matInput [placeholder]=" lang == 'en' ? 'Enter your username' : 'ادخل اسمك'" formControlName="username">
                                <mat-error *ngIf="getRegisterFormControl('username').touched&& getRegisterFormControl('username').invalid" >{{getUserNameErrorMessage(getRegisterFormControl('username'),lang)}}</mat-error>
                                </mat-form-field>
                            </div>


                            <div class="col-12">
                                <mat-form-field color="accent" appearance="fill" class="authForm">
                                <input matInput type="email" [placeholder]=" lang == 'en' ? 'Enter your email' : 'ادخل بريدك الالكتروني'" formControlName="email">
                                <mat-error *ngIf="getRegisterFormControl('email').touched&& getRegisterFormControl('email').invalid">{{getEmailErrorMessage(getRegisterFormControl('email'),lang)}}</mat-error>
                                </mat-form-field>
                            </div>


                            <div class="col-12">
                                <mat-form-field color="accent" appearance="fill" class="authForm">
                                    <input
                                        matInput
                                        [type]="hidePassword ? 'password' : 'text'"
                                        [placeholder]="lang == 'en' ? 'Enter your password' : 'ادخل كلمة المرور'"
                                        formControlName="password"nvs
                                        
                                    />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        (click)="hidePassword = !hidePassword"
                                        [attr.aria-label]="'Hide password'"
                                        [attr.aria-pressed]="hidePassword"
                                    >
                                        <!-- <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon> -->
                                    </button>
                                    <mat-error *ngIf="getRegisterFormControl('password').touched && getRegisterFormControl('password').invalid">
                                        {{ getPasswordErrorMessage(getRegisterFormControl('password'), lang) }}
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-12">
                                <mat-form-field color="accent" appearance="fill" class="authForm">
                                    <input
                                        matInput
                                        [type]="hideConfirmPassword ? 'password' : 'text'"
                                        [placeholder]="lang == 'en' ? 'Confirm your password' : 'تأكيد كلمة المرور'"
                                        formControlName="confirmPassword"
                                    />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        (click)="hideConfirmPassword = !hideConfirmPassword"
                                        [attr.aria-label]="'Hide confirm password'"
                                        [attr.aria-pressed]="hideConfirmPassword"
                                    >
                                        <!-- <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon> -->
                                    </button>
                                    <mat-error *ngIf="getRegisterFormControl('confirmPassword').touched && getRegisterFormControl('password').touched && getRegisterFormControl('confirmPassword').errors">
                                        {{ lang === "en" ? "Password does not match." : ".كلمة السر غير متطابقة" }}
                                    </mat-error>

                                </mat-form-field>
                            </div>



                            <div class="col-12 mt-5" (click)="registerSubmit()">
                                <button *ngIf="!isLoading" class="submitBtn" mat-button color="primary" [disabled]="isLoading || authService.registerForm.invalid">
                                    {{translate.currentLang=='en'?'Sign up':'تسجيل'}}</button>
                                <mat-spinner *ngIf="isLoading"></mat-spinner>
                            </div>

                            <div class="col-12 mt-3" style="text-align:start ;">
                                <span class="noAccount">{{translate.currentLang=='en'?'Already have an account?':'مستخدم حالي؟'}}</span>
                                <span class="crateAccount" (click)="toLogin()">
                                    {{translate.currentLang=='en'?'Sign in':'سجل دخول'}}
                                </span>
                            </div>
                            <!-- <div class="col-12 breakLine">
                                <div class="d-flex">
                                    <div class="line"></div>
                                    <span class="or-text">{{translate.currentLang=='en'?'OR':'أو'}}</span>
                                    <div class="line"></div>
                                </div>
                            </div> -->

                            <!-- <div (click)="submitFbLogin()" class="col-12 col-xl-6 mb-3">
                                <button class="social-login" mat-button>
                                    <img class="social-login-icon" src="assets/img/albaraq/icons/facebook.svg" alt="">
                                    <span class="social-login-text">{{translate.currentLang=='en'?'Sign in with
                                        Facebook':'تسجيل بواسطة فيسبوك'}}</span>
                                </button>
                            </div> -->

                            <!-- <div class="col-12 col-xl-6">
                                <button class="social-login" mat-button>
                                    <img class="social-login-icon" src="assets/img/albaraq/icons/google.svg" alt="">
                                    <span class="social-login-text">{{translate.currentLang=='en'?'Sign in with
                                        Google':'تسجيل بواسطة جوجل'}}</span>
                                </button>
                            </div> -->


                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div>

</mat-dialog-content>